import { render } from "./tw-tabpanel.vue?vue&type=template&id=6ab0779f"
import script from "./tw-tabpanel.vue?vue&type=script&lang=js"
export * from "./tw-tabpanel.vue?vue&type=script&lang=js"
script.render = render

export default script